import React from "react";
import "./Home.css";
import API_CONFIG from "../config/api";

const Benefits = ({ mainTitle, subTitle, benefits }) => {
  return (
    <section className="benefits-section">
      <div className="container">
        <h2 className="section-title">
          {mainTitle} <br />
          {subTitle}
        </h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="benefit-card" key={index}>
              <div className="benefit-icon">
                <img src={`${API_CONFIG.IMAGES_URL}/${benefit.image}`} alt={benefit.title} />
              </div>
              <div className="benefit--title">
                <h3>{benefit.title}</h3>
              </div>
              <div className="benefit-description">
                <p>{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
